// API configuration
const config = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:3001',
  
  // Development mode - bypasses payment checks when true
  // Set via REACT_APP_BYPASS_PAYMENT_GATE environment variable
  // WARNING: Should NEVER be true in production
  BYPASS_PAYMENT_GATE: process.env.REACT_APP_BYPASS_PAYMENT_GATE === 'true' || false
};

export default config;